'use client';

import { useState } from 'react';

interface ChatRatingProps {
  locale: string;
  onRate: (stars: number) => void;
}

export function ChatRating({ locale, onRate }: ChatRatingProps) {
  const [hover,    setHover]    = useState(0);
  const [selected, setSelected] = useState(0);
  const ar = locale === 'ar';

  if (selected > 0) {
    return (
      <p className="text-center text-xs text-(--muted) py-2 animate-fade-in">
        {ar ? '🙏 شكراً! رأيك يساعدنا على التحسين' : '🙏 Thanks for the feedback!'}
      </p>
    );
  }

  return (
    <div className={`flex flex-col items-center gap-1.5 py-2 ${ar ? 'rtl' : ''}`}>
      <p className="text-xs text-(--muted)">
        {ar ? 'كيف كانت هذه المحادثة؟' : 'How was this conversation?'}
      </p>
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            onClick={() => { setSelected(star); onRate(star); }}
            aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
            className="text-xl leading-none transition-transform duration-100 hover:scale-125 cursor-pointer"
          >
            <span className={(hover || selected) >= star ? 'text-yellow-400' : 'text-(--border)'}>
              ★
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ChatRating;
